// DataContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';

const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const [userData, setUserData] = useState({}); // Initialize with empty object

  useEffect(() => {
    // Load data from local storage during component mount
    const storedData = JSON.parse(localStorage.getItem('user')) || {};
    setUserData(storedData);
  }, []);

  useEffect(() => {
    // Update local storage when userData changes
    localStorage.setItem('user', JSON.stringify(userData));
  }, [userData]);

  return (
    <DataContext.Provider value={{ userData, setUserData }}>
      {children}
    </DataContext.Provider>
  );
};

export const useData = () => useContext(DataContext);
